import type { QueryClient } from '@tanstack/react-query';

import { GradeService } from './gradeService';
import { GradeKey } from './keys';

export interface GetUserGroupGradesPrefetchParams {
  userId: number;
  groupId: number;
  queryClient: QueryClient;
}

export function getUserGroupGradesPrefetch(params: GetUserGroupGradesPrefetchParams) {
  const { userId, groupId, queryClient } = params;

  queryClient.prefetchQuery({
    queryKey: [GradeKey.USER_GROUP_GRADES, userId, groupId],
    queryFn: () => GradeService.getUserGroupGrades(userId, groupId).then((response) => response.data),
    staleTime: 60000,
  });
}
